export default __webpack_public_path__ + "static/media/slider1it.6bc4075c.jpg";